import React, { useEffect, useState } from "react";
import ui from "../DashboardUI.module.css";
import styles from "./DirectoryUI.module.css";
import { getCompanyWork } from "../../../services/directoryService";
import { errorMessage } from "../../../utils/errorMessage";

const Section = ({ title, items, formatMoney, empty }) => (
  <>
    <h4 className={styles.tabHeading}>{title}</h4>
    {items.length === 0 ? (
      <p className={styles.tabEmpty}>{empty}</p>
    ) : (
      <div className={styles.tabList}>
        {items.map((item) => (
          <div key={item.project_id ?? item.lead_id} className={ui.assignedItem}>
            <div className={ui.employeeInfo}>
              <span className={ui.employeeName}>{item.project_name || "Untitled"}</span>
            </div>
            {item.status && <span className={styles.statusChip} style={{ color: item.color || "#6b7280" }}>{item.status}</span>}
            {item.value != null && <span className={styles.workValue}>{formatMoney(item.value)}</span>}
          </div>
        ))}
      </div>
    )}
  </>
);

// Projects & leads tab of the company form: what is live for this client, and what it is worth.
export default function CompanyWorkTab({ clientCompanyId, formatMoney, onError }) {
  const [work, setWork] = useState(null);

  useEffect(() => {
    let cancelled = false;
    getCompanyWork(clientCompanyId)
      .then((data) => !cancelled && setWork(data))
      .catch((err) => !cancelled && onError(errorMessage(err, "Could not load projects and leads.")));
    return () => { cancelled = true; };
  }, [clientCompanyId, onError]);

  if (!work) return <p className={styles.tabEmpty}>Loading…</p>;
  return (
    <div>
      <Section title="Active projects" items={work.projects} formatMoney={formatMoney} empty="No active projects for this client." />
      <Section title="Open leads" items={work.leads} formatMoney={formatMoney} empty="No open leads for this client." />
    </div>
  );
}
